import { MaterialReactTable, MRT_GlobalFilterTextField, useMaterialReactTable } from 'material-react-table';
import { Box, Button, lighten, Stack } from '@mui/material';
import { RemoveRedEye } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { language_PT_BR } from '@/components/Base/CustomLocales/language_PT_BR.ts';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { truncate } from 'fs';

const TableTermometroPendencias = ({ type, data }) => {
  const navigate = useNavigate();

  const columns = [
    {
      accessorKey: 'name',
      header: 'Aluno',
      sortDescFirst: true,
      enableMultiSort: true,
      Cell: ({ renderedCellValue }) => <Box>{renderedCellValue}</Box>,
    },
    {
      accessorKey: 'score',
      header: type === 'high' ? 'Score alto' : type === 'intermediary' ? 'Score int...' : 'Score abaixo da média',
      Cell: ({ renderedCellValue }) => (
        <Box
          sx={{
            backgroundColor:
              type === 'high' ? 'rgba(206, 250, 206, 1)' : type === 'intermediary' ? '#FEF8CB' : '#FCE4D4',
            height: '60px',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '5px',
          }}
        >
          {renderedCellValue}
        </Box>
      ),
    },
    {
      accessorKey: 'total_recommendations',
      header: 'Quantidade de recomendações recebidas',
      size: 300,
      Cell: ({ renderedCellValue }) => (
        <Box
          sx={{ textAlign: 'center' }}
        >
          {renderedCellValue}
        </Box>
      ),
    },
    {
      accessorKey: 'is_active',
      header: 'Status',
      Cell: ({ renderedCellValue }) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            background: 'rgba(239, 239, 239, 1)',
            borderRadius: '32px',
            padding: '4px 8px',
            textAlign: 'center',
            justifyContent: 'center',
            width: '100px',
          }}
        >
          <div
            style={{
              background: renderedCellValue ? 'rgba(15, 219, 98, 1)' : 'rgba(255, 0, 0, 1)', // Verde para ativo, vermelho para inativo
              borderRadius: '50%',
              width: '10px',
              height: '10px',
              marginRight: '5px',
              textAlign: 'center',
            }}
          ></div>
          <div>
            {renderedCellValue ? 'Ativo' : 'Inativo'}
          </div>

          <KeyboardArrowDown sx={{ marginLeft: '5px' }} />
        </div>
      ),
    },
    {
      accessorKey: 'student_id',
      header: 'ID',
      enableHiding: true,
      enableSorting: false,
      enableResizing: false,
      size: 0,
    },
  ];

  const tableBasic = useMaterialReactTable({
    columns,
    data,
    localization: {
      search: 'Pesquisar por nome do aluno',
      actions: 'Ações', 
    },
    positionActionsColumn: 'last',
    enableColumnFilterModes: false,
    enableColumnOrdering: false,
    enableGrouping: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnFilters: false,
    enableHiding: false,
    enableExpandAll: false,
    enableRowDragging: false,
    enableColumnActions: false,
    enablePagination: false,
    enableRowActions: true,
    enableRowSelection: false,
    enableBottomToolbar: false,
    enableGlobalFilter: true,
    muiPaginationProps: {
      color: 'primary',
      shape: 'rounded',
      showRowsPerPage: false,
      variant: 'outlined',
    },
    initialState: {
      showGlobalFilter: true,
      columnVisibility: {
        student_id: false,
      },
    },
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      variant: 'outlined',
      size: 'small',
      fullWidth: true,                
      placeholder: 'Pesquisar por nome…',
    },
    renderRowActions: ({ row }) => {
      const studentId = data[row.index].student_id;
      const nameStudent = data[row.index].name;

      return (
        <Stack alignItems={'center'}>
          <RemoveRedEye
            sx={{
              cursor: 'pointer'
            }}
            onClick={() => navigate('/inadimplencia-recomendacoes-alunos', { state: { id: studentId, name: nameStudent } })}
          />
        </Stack>
      );
    },
    muiTableHeadCellProps: ({ column }) => {
      return {
        sx: {
          backgroundColor: '#f7f7f7',
          color: 'black',
          fontWeight: 400,
          fontSize: '12px',
          textAlign: column.id === 'mrt-row-select' ? 'center' : 'left',
          padding: column.id === 'mrt-row-select' ? '16px' : undefined,
        },
      };
    },
    muiTableBodyCellProps: ({ column }) => {
      return {
        sx: {
          backgroundColor: '#fff',
          color: 'rgba(128, 128, 128, 1)',
          fontWeight: 400,
          fontSize: '12px',
          padding: '0',
          textAlign: column.id === 'mrt-row-select' ? 'center' : 'left',
        },
      };
    },
    renderTopToolbar: ({ table }) => (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p={1}
      >
        {/* LEFT‑aligned, full width filter */}
        <Box flexGrow={6} mr={2}>
          <MRT_GlobalFilterTextField
            table={table}
            //@ts-ignore
            textFieldProps={{
              placeholder: 'Pesquisar por nome do aluno…',
              variant: 'outlined',
              size: 'small',
              fullWidth: true,
            }}
          />
        </Box>

        {/* if you have any right‑side buttons, put them here */}
        {/* <Button onClick={…}>My Action</Button> */}
      </Box>
    )
  });

  return (
    <Box
    sx={{
      width: '100%', 
      overflowY: 'auto',
      overflowX: 'auto', 
      borderRadius: '5px',
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: '#555',
      },
    }}
    >
      <MaterialReactTable table={tableBasic} />
    </Box>
  );
};

export default TableTermometroPendencias;
